import { VisitorEvent } from '../../shared/models/visitor.event';
import { VisitorPlace } from '../../shared/models/visitor.place';
import { TravelMode } from '../../shared/services/google.map.service';

export class Itinerary {
  _id: string;
  hubName: string;
  title: string;
  description: string;
  image: string;
  order: number;
  stops: number;
  distance: number;
  travelTime: number;
  isActive: boolean;
  attractions: ItineraryAttraction[];
  defaultTravelMode: {
    mode: string;
    canChange: boolean;
  };
  customFields: {
    field: string;
    // value: string
  }[];
  detailsStyle: 'map' | 'story' | 'map3d';
  mapStyle: 'light' | 'dark';

  releaseDate?: Date;
  expiryDate?: Date;

  widgetCodes: string[];

  settings: ItinerarySettings;
}

export type ItineraryAttraction = {
  feedId: string;
  feedType: string;
  order: number;
  _id: string;
  item: VisitorEvent | VisitorPlace;
  preDescription?: string;
  postDescription?: string;
  mapIcon?: string;
  mapStyle: 'light' | 'dark';
  detailsStyle: 'map' | 'map3d' | 'story';
};

export class CreateItineraryCommand {
  hubName: string;
  title: string;
  description: string;
  imageLink: string;
  order: number;
  isActive: boolean;
  defaultTravelMode: {
    mode: string;
    canChange: boolean;
  };
  customFields: {
    field: string;
    // value: string
  }[];
  detailsStyle: 'map' | 'map3d' | 'story';
  mapStyle: 'light' | 'dark';
  releaseDate?: Date;
  expiryDate?: Date;
  widgetCodes?: string[];
}

export class ItinerarySettings {
  constructor() {
    this.bgImage = '';
    this.bgColor = '#00000099';
    this.title1 = {
      text: 'DISCOVER',
      color: 'white',
    };
    this.title2 = {
      text: 'YOUR DESTINATION',
      color: 'white',
    };
    this.intro = {
      text: 'Say something about your destination here',
      color: '#ffffff',
    };
    this.itineraryDescription = {
      color: '#ffffff',
    };
  }

  bgImage: string;
  bgColor: string; //'#00000099',
  title1: {
    text: string; //'DISCOVER',
    color: string; //'white',
  };
  title2: {
    text: string; //'SAVANNAH, GA',
    color: string; //'white',
  };
  intro: {
    text: string; //'Savannah, Georgia, is a charming Southern escape where art, period architecture, trendy boutiques and haunted stories are all set under a veil of Spanish moss.',
    color: string; //'#ffffff',
  };
  itineraryDescription: {
    color: string; //'#ffffff',
  };
}

export class MultiWidgetSettings {
  title: string;
  code: string;
  settings: ItinerarySettings;
}
